import React, { useState } from "react";
import { BillingInfo } from "@/Contracts/Users";
import "./index.less";
import useDispatch from "@/Components/Utils/useDispatch";
import UsersActionCreators from "@/Actions/User";
import { GlobalState } from "@/Reducers/interface";
import { useSelector } from "react-redux";
import ZMessage from "@molecules/ZMessage";
import ZButton from "@atoms/ZButton";
import { CreditCardDetailsProps } from "./interface";
import { useOnboardingDispatch } from "@/Onboarding/store";
import OnboardingActionCreators from "@/Onboarding/store/actions";
import LoginActionCreators from "@/Actions/Login";
import { useInitOnboarding } from "@/Onboarding/hooks/useInitOnboarding";
import {
	UpdateCheckListBarDataPayload,
	UpdateCheckListBarDataRequest
} from "@/Onboarding/contracts";
import { ZTypography } from "@atoms";
import { EFontWeights } from "@atoms/ZTypography/interface";
import CardFormComponent from "@/Components/UI/PaymentModal/CardFormComponent";

const ZCreditCardDetails = (props: CreditCardDetailsProps) => {
	const { isLoading, billingInfo, isCPQBuilderUser } = useSelector(
		(state: GlobalState) => {
			return {
				isLoading: state.user.isBillingInfoLoading,
				billingInfo: state.user.billingInfo,
				isCPQBuilderUser:
					!!state.user.userCompany?.signup_extra_info
						?.signup_document_type_selected
			};
		}
	);

	const onboardingDispatch = useOnboardingDispatch();
	const { initOnboarding } = useInitOnboarding();

	const [cardFormComponentOpen, setCardFormComponentOpen] =
		useState<boolean>(false);

	const dispatch = useDispatch();

	const cardFormComponentSubmit = async () => {
		try {
			dispatch(UsersActionCreators.showBillingInfoLoader());
			await dispatch(UsersActionCreators.confirmCardAdded());
			ZMessage.success("Card details successfully captured!");
			dispatch(LoginActionCreators.loginFromAuth0());
			await dispatch(UsersActionCreators.getSubscriptionDetails());
			await dispatch(UsersActionCreators.getSubscriptionPlans());

			const requestPayload: UpdateCheckListBarDataPayload = {
				is_checklist_active: true
			};
			const request: UpdateCheckListBarDataRequest = {
				requestPayload,
				hasAPIUpdate: true
			};
			await onboardingDispatch(
				OnboardingActionCreators.updateCheckListBarData(request)
			);
			initOnboarding(true, false);
			props.onClose?.();
		} catch (error) {
			console.error(error);
		} finally {
			cardFormComponentClosed();
			dispatch(UsersActionCreators.hideBillingInfoLoader());
		}
	};

	const cardFormComponentClosed = () => {
		setCardFormComponentOpen(false);
	};

	return (
		<div className="flex-col align-center">
			<div className="grid align-center my-15">
				<ZTypography.ZText weight={EFontWeights.MEDIUM}>
					{BillingInfo.promptMessageForPayment(billingInfo)}
				</ZTypography.ZText>
				<ZButton
					type="primary"
					className="my-4 mx-auto"
					loading={isLoading}
					disabled={isLoading}
					onClick={() => setCardFormComponentOpen(true)}
				>
					Manage Payment Method
				</ZButton>
				{isCPQBuilderUser && (
					<ZTypography.ZText
						italic
						colorVariant={7}
						level={0}
						className="inline-block"
					>
						*Updating your payment information is solely for account
						management purposes. Our free plan doesn't imply
						charges, you will be billed only if you upgrade to a
						premium plan.
					</ZTypography.ZText>
				)}
			</div>
			{cardFormComponentOpen && (
				<CardFormComponent
					onSubmit={cardFormComponentSubmit}
					onClose={cardFormComponentClosed}
				/>
			)}
		</div>
	);
};

export default ZCreditCardDetails;
